import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import Card from '../ui/Card';
import Button from '../ui/Button';

const {FiAlertCircle, FiRefreshCw} = FiIcons;

export default function PlanAccessUnavailable({onRetry}) {
  return (
    <div className="mx-auto max-w-2xl px-4 py-12 sm:px-6 lg:py-20">
      <Card interactive={false} className="p-7 text-center sm:p-10">
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-amber-50 text-amber">
          <SafeIcon icon={FiAlertCircle} className="h-6 w-6" />
        </span>
        <h1 className="mt-6 text-2xl font-bold tracking-tight text-ink">
          Feature access is temporarily unavailable
        </h1>
        <p className="mx-auto mt-3 max-w-lg text-sm leading-6 text-gray-600">
          SilaTrail could not verify the plan for this Business. No feature access has been assumed. Try again before continuing.
        </p>
        <div className="mt-7 flex justify-center">
          <Button variant="secondary" onClick={onRetry}>
            <SafeIcon icon={FiRefreshCw} className="h-4 w-4" />
            Try again
          </Button>
        </div>
      </Card>
    </div>
  );
}
